import { mentionLabel, MENTION_TOKEN } from '@/components/mentions/mention-state';

export function MentionText({ text }: { text: string }) {
  const nodes: Array<string | { token: string; key: string }> = [];
  let cursor = 0;
  for (const match of text.matchAll(MENTION_TOKEN)) {
    const start = match.index ?? 0;
    if (start > cursor) nodes.push(text.slice(cursor, start));
    nodes.push({ token: match[0], key: `${start}-${match[0]}` });
    cursor = start + match[0].length;
  }
  if (cursor < text.length) nodes.push(text.slice(cursor));

  return (
    <>
      {nodes.map((node, index) =>
        typeof node === 'string' ? (
          <span key={`t-${index}`}>{node}</span>
        ) : (
          <span key={node.key} className="font-bold text-foreground">
            {mentionLabel(node.token)}
          </span>
        )
      )}
    </>
  );
}
